import React from "react";
import DashBoardDesktop from "./DashBoardDesktop";
import DashBoardMobile from "./DashBoardMobile";
import Navbar from "../navbar/Navbar";

const DashBoardMainView = (props) => {
  return (
    <>
      <Navbar />
      <DashBoardDesktop props={props} />
      <DashBoardMobile props={props} />
    </>
  );
};

export default DashBoardMainView;
